const pep = {
  namespaced: true,
  state: {
    dependents: [],
    dependent_id: '',
    indirect_peps_array: [],
    indirect_pep_id: ''
  },
  getters: {
    getDependents: state => {
      return state.dependents
    },
    getDependentByID: (state) => (id) => {
      return state.dependents[id]
    },
    getDependentID: state => {
      return state.dependent_id
    },
    getIndirectPeps: state => {
      return state.indirect_peps_array
    },
    getIndirectPepByID: (state) => (id) => {
      return state.indirect_peps_array[id]
    },
    getIndirectPepID: state => {
      return state.indirect_pep_id
    }
  },
  actions: {
    addDependent ({commit}, dependent) {
      const newDependent = {
        name: dependent.name,
        middle_name: dependent.fatherSurname,
        last_name: dependent.motherSurname,
        relationship: dependent.relationship,
        rfc_curp: dependent.rfcOrCurp.toUpperCase()
      }
      commit('ADD_DEPENDENT', newDependent)
    },
    deleteDependent ({commit}, dependentID) {
      commit('DELETE_DEPENDENT', dependentID)
    },
    setDependentID ({commit}, dependentID) {
      commit('SET_DEPENDENT_ID', dependentID)
    },
    removeDependentID ({commit}) {
      commit('REMOVE_DEPENDENT_ID')
    },
    updateDependent ({commit, dispatch}, dependent) {
      dispatch('removeDependentID')
      commit('UPDATE_DEPENDENT', dependent)
    },
    addIndirectPeps ({commit}, indirectPep) {
      const newIndirectPep = {
        name: indirectPep.name,
        middle_name: indirectPep.fatherSurname,
        last_name: indirectPep.motherSurname,
        relationship: indirectPep.relationship,
        start: indirectPep.startWorkingDate,
        end: indirectPep.finishWorkingDate,
        profession: indirectPep.profession,
        position: indirectPep.position,
        government_dependence: indirectPep.governmentDependence,
        current_job: indirectPep.currentJob,
        gov_funds: indirectPep.govFunds
      }
      commit('ADD_INDIRECT_PEP', newIndirectPep)
    },
    deleteIndirectPep ({commit}, indirectPepID) {
      commit('DELETE_INDIRECT_PEP', indirectPepID)
    },
    setIndirectPepID ({commit}, indirectPepID) {
      commit('SET_INDIRECT_PEP_ID', indirectPepID)
    },
    removeIndirectPepID ({commit}) {
      commit('REMOVE_INDIRECT_PEP_ID')
    },
    updateIndirectPep ({commit, dispatch}, indirectPepID, indirectPep) {
      dispatch('removeIndirectPepID')
      commit('UPDATE_INDIRECT_PEP', indirectPepID, indirectPep)
    }
  },
  mutations: {
    ADD_DEPENDENT (state, newDependent) {
      const newRegistry = state.dependents.length
      state.dependents[newRegistry] = newDependent
    },
    DELETE_DEPENDENT (state, dependentID) {
      state.dependents.splice(dependentID, 1)
    },
    SET_DEPENDENT_ID (state, dependentID) {
      state.dependent_id = dependentID
    },
    REMOVE_DEPENDENT_ID (state) {
      state.dependent_id = ''
    },
    UPDATE_DEPENDENT (state, dependent) {
      const {
        id,
        name,
        fatherSurname,
        motherSurname,
        relationship,
        rfcOrCurp
      } = {...dependent}
      state.dependents[id].name = name
      state.dependents[id].middle_name = fatherSurname
      state.dependents[id].last_name = motherSurname
      state.dependents[id].relationship = relationship
      state.dependents[id].rfc_curp = rfcOrCurp
    },
    ADD_INDIRECT_PEP (state, newInderectPep) {
      const newRegistry = state.indirect_peps_array.length
      state.indirect_peps_array[newRegistry] = newInderectPep
    },
    DELETE_INDIRECT_PEP (state, indirectPepID) {
      state.indirect_peps_array.splice(indirectPepID, 1)
    },
    SET_INDIRECT_PEP_ID (state, indirectPepID) {
      state.indirect_pep_id = indirectPepID
    },
    REMOVE_INDIRECT_PEP_ID (state) {
      state.indirect_pep_id = ''
    },
    UPDATE_INDIRECT_PEP (state, indirectPep) {
      const {
        id,
        name,
        fatherSurname,
        motherSurname,
        relationship,
        startWorkingDate,
        finishWorkingDate,
        profession,
        position,
        governmentDependence,
        currentJob,
        govFunds
      } = {...indirectPep}
      state.indirect_peps_array[id].name = name
      state.indirect_peps_array[id].middle_name = fatherSurname
      state.indirect_peps_array[id].last_name = motherSurname
      state.indirect_peps_array[id].relationship = relationship
      state.indirect_peps_array[id].start = startWorkingDate
      state.indirect_peps_array[id].end = finishWorkingDate
      state.indirect_peps_array[id].profession = profession
      state.indirect_peps_array[id].position = position
      state.indirect_peps_array[id].government_dependence = governmentDependence
      state.indirect_peps_array[id].current_job = currentJob
      state.indirect_peps_array[id].gov_funds = govFunds
    }
  }
}

export default pep



// WEBPACK FOOTER //
// ./src/store/pep.js